export const campaignsContext = 'campaign'